import { render, staticRenderFns } from "./OpenBankingIncidentInfo.vue?vue&type=template&id=104c9a60&scoped=true"
import script from "./OpenBankingIncidentInfo.vue?vue&type=script&lang=js"
export * from "./OpenBankingIncidentInfo.vue?vue&type=script&lang=js"
import style0 from "./OpenBankingIncidentInfo.vue?vue&type=style&index=0&id=104c9a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c9a60",
  null
  
)

export default component.exports